export enum ContentType {
	Album = 'album',
	Artist = 'artist',
	Playlist = 'playlist',
	Track = 'track',
	User = 'user',
	Podcast = 'podcast',
	Episode = 'episode',
	Label = 'label',
	SubLabel = 'subLabel',
	Release = 'release',
	Pitch = 'pitch',
	Provider = 'provider',
}
